var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNoDevice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 77,
    height: 77,
    viewBox: "0 0 77 77",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.13292 0L0 5.13292L11.0337 16.1667H8.08333C7.01142 16.1667 5.9834 16.5925 5.22544 17.3504C4.46748 18.1084 4.04167 19.1364 4.04167 20.2083V60.625C4.04167 61.6969 4.46748 62.7249 5.22544 63.4829C5.9834 64.2409 7.01142 64.6667 8.08333 64.6667H56.5833C57.3917 64.6667 58.1596 64.3433 58.7658 63.9392L71.6587 76.7917L76.7917 71.6587M76.7917 18.1875L60.625 34.3542V20.2083C60.625 19.1364 60.1992 18.1084 59.4412 17.3504C58.6833 16.5925 57.6552 16.1667 56.5833 16.1667H31.6058L76.7917 61.3525V18.1875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNoDevice);
export default __webpack_public_path__ + "static/media/icon-no-device.f9668118d4087676f8b020d2e1fdf378.svg";
export { ForwardRef as ReactComponent };